import { render, staticRenderFns } from "./removal-tank-info.vue?vue&type=template&id=a8f9261c&"
import script from "./removal-tank-info.vue?vue&type=script&lang=js&"
export * from "./removal-tank-info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports